export default __webpack_public_path__ + "static/media/icon_refreshmap.cf59bb1c.png";